import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../../services/authService';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const token = authService.getStoredToken();
  const user = authService.getStoredUser();

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
